import { Typography } from "@mui/material";

/** Common style element for sub headings */
export function SoftTitle({ children, ...restProps }) {
  return (
    <Typography variant="subtitle2" color="textSecondary" {...restProps}>
      {children}
    </Typography>
  );
}
